export default __webpack_public_path__ + "static/media/02.83e0ebc3.webp";